//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import {
    CreateAccountingRecord,
    ListAccountingRecords,
    ShowAccountingRecord,
} from '@/views/accountingRecords'

//
export default {
    path: 'accounting_records',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'accounting-records-list',
            component: ListAccountingRecords,
        },
        {
            path: 'create',
            name: 'accounting-records-create',
            component: CreateAccountingRecord,
        },
        {
            path: ':id',
            name: 'accounting-records-update',
            component: ShowAccountingRecord,
        },
    ],
    meta: {
        group: 'Contabilidad',
        title: 'Asientos contables',
    },
}
